import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import BarChartIcon from '@mui/icons-material/BarChart';

interface GraphButtonProps {
  onShowGraph: () => void;
  styleOverrides?: React.CSSProperties;
  disabled?: boolean;
}

export default function GraphButton({ onShowGraph, styleOverrides, disabled }: GraphButtonProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  return (
    <div style={styleOverrides}>
      <Button
        variant="contained"
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        startIcon={<BarChartIcon />}
        disabled={disabled}
      >
        Graph Data
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={() => { onShowGraph(); handleClose(); }}>
          Cellular Graphs
        </MenuItem>
      </Menu>
    </div>
  );
}
